<script lang="ts">
  // @ts-nocheck
  // Getting strange issue from this file in svelte-check:
  // /home/runner/work/community/community/frontend/web-app/src/components/editor/extensions/blocks/BubbleMenu/BubbleMenuBar.svelte:48:5
  // Error: Type '(props: { editor: Editor; view: EditorView; state: EditorState; oldState?: EditorState | undefined; from: number; to: number; }) => boolean' is not assignable to type 'null | undefined'. (ts)
  // As a result, we have decided to ignore this file for now.
  import type { BubbleMenuPluginProps } from "@tiptap/extension-bubble-menu";
  import { isTextSelection } from "@tiptap/core";
  import { BubbleMenu, type Editor } from "svelte-tiptap";
  import MenuBar from "./MenuBar.svelte";

  export let editor: Editor;
  export let aiMode = false;

  // Custom bubble menu to prevent showing for titles
  const showShowBubbleMenu: Exclude<BubbleMenuPluginProps["shouldShow"], null> = ({
    editor,
    view,
    state,
    from,
    to,
  }) => {
    // don't show the bubble menu for titles
    if (
      editor.isActive("title") ||
      editor.isActive("file") ||
      editor.isActive("video") ||
      editor.isActive("image")
    )
      return false;

    // -- from here copied from @tiptap BubbleMenu
    const { doc, selection } = state;
    const { empty } = selection;

    // Sometime check for `empty` is not enough.
    // Doubleclick an empty paragraph returns a node size of 2.
    // So we check also for an empty text size.
    const isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);

    // When clicking on a element inside the bubble menu the editor "blur" event
    // is called and the bubble menu item is focussed. In this case we should
    // consider the menu as part of the editor and keep showing the menu
    // const isChildOfMenu = .element.contains(document.activeElement)

    const hasEditorFocus = view.hasFocus();

    if (!hasEditorFocus || empty || isEmptyTextBlock || !editor.isEditable) {
      return false;
    }

    return true;
  };
</script>

{#if editor}
  <BubbleMenu
    {editor}
    shouldShow={showShowBubbleMenu}
    tippyOptions={{ appendTo: document.body, maxWidth: "none" }}
  >
    <MenuBar {editor} {aiMode} />
  </BubbleMenu>
{/if}
